// extracted by mini-css-extract-plugin
module.exports = {"green":"RichText_green__RxtrK","red":"RichText_red__6bqfi","yellow":"RichText_yellow__Z6Pah","blue":"RichText_blue__HYtBb"};